var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({}, 'vertical-form-table', {
    items: _vm.items
  }, false), [_c('template', {
    slot: "문의내용"
  }, [_vm._v(" " + _vm._s(_vm.form.content) + " ")]), _c('template', {
    slot: "문의답변"
  }, [_c('div', {
    staticClass: "ma-n3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-textarea', _vm._b({
    model: {
      value: _vm.form.reply,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reply", $$v);
      },
      expression: "form.reply"
    }
  }, 'v-textarea', Object.assign({}, _vm.attrs_input__verticalTable, {
    loading: _vm.loading
  }), false)), _c('v-btn', _vm._b({
    staticClass: "mr-n4 mt-n4",
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "text": "",
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": _vm.update
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(" 저장하기")])], 1)])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }